import { createAsyncThunk } from '@reduxjs/toolkit'

import { callErrorMsg } from 'helpers/errorMsg'
import { toastSuccess } from 'utils/toast'

import {
  fetchVendorRolesApi,
  fetchVendorAccountsApi,
  deleteVendorAccountApi,
  SendVendorEmailRequestInterface,
  postSendVendorEmailApi,
} from '../../services/vendorPortalAccounts'
import {
  sliceName,
  setLoading,
  setShimmerLoading,
  setVendorRoles,
  setVendorAccounts,
} from './vendorPortalAccountsSlice'

export const fetchVendorRoles = createAsyncThunk(
  `${sliceName}/fetchVendorRoles`,
  async (_, { dispatch }) => {
    try {
      const { data } = await fetchVendorRolesApi()
      dispatch(setVendorRoles(data.data?.roles || []))
    } catch (error) {
      callErrorMsg(error)
    }
  },
)

export const fetchVendorPortalAccounts = createAsyncThunk(
  `${sliceName}/fetchVendorPortalAccounts`,
  async (vendorId: string, { dispatch }) => {
    try {
      dispatch(setShimmerLoading(true))
      const { data } = await fetchVendorAccountsApi(vendorId)
      dispatch(setVendorAccounts(data.data?.users || []))
    } catch (error) {
      callErrorMsg(error)
    } finally {
      dispatch(setShimmerLoading(false))
    }
  },
)

export const submitUpdateVendorPortal = createAsyncThunk(
  `${sliceName}/submitUpdateVendorPortal`,
  async (
    {
      payload,
      action,
      isSuspended,
      cb,
    }: {
      payload: SendVendorEmailRequestInterface
      action: string
      isSuspended?: boolean
      cb?: () => void
    },
    { dispatch },
  ) => {
    try {
      dispatch(setLoading(true))
      await postSendVendorEmailApi(payload)

      if (action === 'resend-email') {
        toastSuccess('Berhasil kirim ulang email konfirmasi')
      } else if (isSuspended) {
        toastSuccess('User berhasil di Suspend!')
      } else if (action === 'edit') {
        toastSuccess('Berhasil mengubah akun!')
      } else {
        toastSuccess('Berhasil menambahkan akun vendor portal.')
      }

      if (cb) cb()
    } catch (error) {
      callErrorMsg(error)
    } finally {
      dispatch(setLoading(false))
    }
  },
)

export const deleteSellerPortalAccount = createAsyncThunk(
  `${sliceName}/deleteSellerPortalAccount`,
  async ({ id, vendorId, cb }: { id: number; vendorId: string; cb?: () => void }, { dispatch }) => {
    try {
      dispatch(setLoading(true))
      await deleteVendorAccountApi(id)
      toastSuccess('User berhasil dihapus!')
      dispatch(fetchVendorPortalAccounts(vendorId))
      if (cb) cb()
    } catch (error) {
      callErrorMsg(error)
    } finally {
      dispatch(setLoading(false))
    }
  },
)
